module.exports = __webpack_public_path__ + "img/ricelog_pinicon_092.01e500ba.png";